import { createSelector } from 'reselect';
import sortBy from 'lodash/sortBy';

export const selectDependentChoicesByOptionId = (optionId) => createSelector(
  (state) => state.availableChoices,
  (choices) => sortBy(choices[optionId], 'value')
);
